// Add your custom JS here.

jQuery(document).ready(function($) {
      $('#owl-gallery').owlCarousel({
      items: 1,
      nav: true,
      navText: [
        "<img src='" + customNavigationPaths.prev + "'>",
        "<img src='" + customNavigationPaths.next + "'>"
        ],
      responsive: {
        0: {
            items: 2,
        },
        320: {
            items: 2,
            margin: 15,
            nav: false,
            loop: true,
            dots: true,
        },
        540: {
            items: 2,
            margin: 15,
            nav: false,
            loop: true,
            dots: true,
        },
        768: {
            items: 2,
            margin: 15,
            loop: true,
            nav: true,
        },
        1000: {
            items: 4,
            dots: false,
            margin: 15,
            nav: true,
            stagePadding: 0,
        },
    }
});
     $('.owl-testimonial-listing').owlCarousel({
      items: 1,
      nav: false,
      dots: true,
      responsive: {
        0: {
            items: 1,
        },
        320: {
            items: 1,
            margin: 0,
            loop: true,
        },
        540: {
            items: 1,
            margin: 0,
            loop: true,
        },
        768: {
            items: 1,
            margin: 0,
            loop: true,
        },
        1000: {
            items: 1,
            dots: true,
            margin: 10,
            nav: false,
        },
    }
});
     $('.owl-participent-logos').owlCarousel({
        loop: true,
        margin: 0,
        rewind: true,
        nav: false,
        dots: false,
        autoHeight: false,
        lazyLoad: true,
        items: 5,
        autoplay: true,
        autoWidth: false,
        stagePadding: 0,
        autoplay: true,
        mergeFit: true,
        merge: false,
        slideTransition: 'linear',
        autoplayTimeout: 2000,
            autoplaySpeed: 2000,
            smartSpeed: 1000,
        // animateIn: 'fadeIn', 
        // animateOut: 'fadeOut',
        responsive: {
            0: {
                items: 2,
                stagePadding: 0,
                autoHeight: false,
                autoWidth: false,
            },
            320: {
                items: 2,
                margin: 10,
                loop: true,
                stagePadding: 0,
            },
            540: {
                items: 2,
                margin: 15,
                loop: true,
                stagePadding: 0,
            },
            768: {
                items: 3,
                margin: 15,
                loop: true,
                stagePadding: 0,
            },
            1000: {
                items: 6,
                dots: false,
                margin: 15,
                nav: true,
                stagePadding: 0,
                navText: ['<i class="bi bi-chevron-left"></i>', '<i class="bi bi-chevron-right"></i>'],
            },
        }
    });
  Fancybox.bind('[data-fancybox="industry-popup"]', {
  	helpers: {
    overlay: {
      css: {
        backgroundColor: "transparent", // white
      },
    },
  },
  compact: false,
        Toolbar: false
});
$('.counter-count span').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
          
          //chnage count up speed here
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
var el = $('.team-member-slide');
  
  var carousel;
  var carouselOptions = {
    margin: 20,
    nav: true,
    dots: false,
    slideBy: 'page',
    navText: ['<i class="bi bi-chevron-left"></i>', '<i class="bi bi-chevron-right"></i>'],
    responsive: {
      0: {
        items: 1,
        nav:false,
        dots: true,
        rows: 2 //custom option not used by Owl Carousel, but used by the algorithm below
      },
      768: {
        items: 2,
        nav:false,
        dots: true,
        rows: 3 //custom option not used by Owl Carousel, but used by the algorithm below
      },
      991: {
        items: 2,
        nav: true,
        dots: false,
        rows: 2 //custom option not used by Owl Carousel, but used by the algorithm below
      }
    }
  };

  //Taken from Owl Carousel so we calculate width the same way
  var viewport = function() {
    var width;
    if (carouselOptions.responsiveBaseElement && carouselOptions.responsiveBaseElement !== window) {
      width = $(carouselOptions.responsiveBaseElement).width();
    } else if (window.innerWidth) {
      width = window.innerWidth;
    } else if (document.documentElement && document.documentElement.clientWidth) {
      width = document.documentElement.clientWidth;
    } else {
      console.warn('Can not detect viewport width.');
    }
    return width;
  };

  var severalRows = false;
  var orderedBreakpoints = [];
  for (var breakpoint in carouselOptions.responsive) {
    if (carouselOptions.responsive[breakpoint].rows > 1) {
      severalRows = true;
    }
    orderedBreakpoints.push(parseInt(breakpoint));
  }
  
  //Custom logic is active if carousel is set up to have more than one row for some given window width
  if (severalRows) {
    orderedBreakpoints.sort(function (a, b) {
      return b - a;
    });
    var slides = el.find('[data-slide-index]');
    var slidesNb = slides.length;
    if (slidesNb > 0) {
      var rowsNb;
      var previousRowsNb = undefined;
      var colsNb;
      var previousColsNb = undefined;

      //Calculates number of rows and cols based on current window width
      var updateRowsColsNb = function () {
        var width =  viewport();
        for (var i = 0; i < orderedBreakpoints.length; i++) {
          var breakpoint = orderedBreakpoints[i];
          if (width >= breakpoint || i == (orderedBreakpoints.length - 1)) {
            var breakpointSettings = carouselOptions.responsive['' + breakpoint];
            rowsNb = breakpointSettings.rows;
            colsNb = breakpointSettings.items;
            break;
          }
        }
      };

      var updateCarousel = function () {
        updateRowsColsNb();

        //Carousel is recalculated if and only if a change in number of columns/rows is requested
        if (rowsNb != previousRowsNb || colsNb != previousColsNb) {
          var reInit = false;
          if (carousel) {
            //Destroy existing carousel if any, and set html markup back to its initial state
            carousel.trigger('destroy.owl.carousel');
            carousel = undefined;
            slides = el.find('[data-slide-index]').detach().appendTo(el);
            el.find('.fake-col-wrapper').remove();
            reInit = true;
          }


          //This is the only real 'smart' part of the algorithm

          //First calculate the number of needed columns for the whole carousel
          var perPage = rowsNb * colsNb;
          var pageIndex = Math.floor(slidesNb / perPage);
          var fakeColsNb = pageIndex * colsNb + (slidesNb >= (pageIndex * perPage + colsNb) ? colsNb : (slidesNb % colsNb));

          //Then populate with needed html markup
          var count = 0;
          for (var i = 0; i < fakeColsNb; i++) {
            //For each column, create a new wrapper div
            var fakeCol = $('<div class="fake-col-wrapper"></div>').appendTo(el);
            for (var j = 0; j < rowsNb; j++) {
              //For each row in said column, calculate which slide should be present
              var index = Math.floor(count / perPage) * perPage + (i % colsNb) + j * colsNb;
              if (index < slidesNb) {
                //If said slide exists, move it under wrapper div
                slides.filter('[data-slide-index=' + index + ']').detach().appendTo(fakeCol);
              }
              count++;
            }
          }
          //end of 'smart' part

          previousRowsNb = rowsNb;
          previousColsNb = colsNb;

          if (reInit) {
            //re-init carousel with new markup
            carousel = el.owlCarousel(carouselOptions);
          }
        }
      };

      //Trigger possible update when window size changes
      $(window).on('resize', updateCarousel);

      //We need to execute the algorithm once before first init in any case
      updateCarousel();
    }
  }

  //init
  carousel = el.owlCarousel(carouselOptions);


  $("#attach-file").change(function() {
        var file_uplaod_msg = $(this).val().replace(/.*(\/|\\)/, '');
        $(".file-upload-msg").html("<span>" + file_uplaod_msg + "</span>")
    });


$('[data-aos]').parent().addClass('hideOverflowOnMobile');


});



   document.querySelectorAll('.accordion-button').forEach(button => {
        button.addEventListener('click', () => {
            const iconPlus = button.querySelector('.fa-plus');
            const iconMinus = button.querySelector('.fa-minus');
            
            if (iconPlus && iconMinus) {
                iconPlus.classList.toggle('d-none');
                iconMinus.classList.toggle('d-none');
            }
        });
    });

AOS.init({
        duration: 1000,
        once: true,
    });